import { createStore } from 'satcheljs';
import { HeaderToastNotificationViewState } from './schema/HeaderToastNotificationViewState';

let initialState: HeaderToastNotificationViewState = {
    notificationViewStates: [],
};

export default createStore<HeaderToastNotificationViewState>(
    'headerToastNotificationViewState',
    initialState
)();
